import { Flex, Input, FormControl, FormLabel } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { orderApi, strategiesApi } from "src/api";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { useExchangeInfoStore } from "src/store";

type Props = {
  stragegyId?: number;
  hideFullScreenButton?: boolean;
};

export default function StatusPanel(props: Props) {
  const { stragegyId } = props;
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const exchangeAccountId = useExchangeInfoStore((state) => state.selectedExchangeAccountId);
  const localtion = useLocation();
  const isSelf = new URLSearchParams(localtion.search).get("isSelf");

  const statusQuery = useQuery({
    queryKey: ["status", props.stragegyId, selectedDate],
    queryFn: () => {
      if (props.stragegyId) {
        return strategiesApi.fetchStrategyStatus(stragegyId, selectedDate || undefined);
      }
      return orderApi.fetchOrdersV2(exchangeAccountId, "Manual");
    },
    refetchInterval: 5000,
    enabled: !!stragegyId,
  });

  let data = statusQuery.data || "";

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(event.target.value);
  };

  return (
    <>
      <Flex width="100%" flexDirection="column">
        {/* 日期选择器 */}
        <FormControl mb={4} maxWidth="300px">
          <FormLabel htmlFor="date-picker">选择日期</FormLabel>
          <Input
            id="date-picker"
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            size="md"
          />
        </FormControl>
        {/* <ReactMarkdown>{data}</ReactMarkdown> */}
        <div dangerouslySetInnerHTML={{ __html: data }} />
      </Flex>
    </>
  );
}